import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import pb from '../lib/pocketbase';

function ConnexionPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user: currentUser, login } = useAuth();

  const [mode, setMode] = useState('login'); // 'login' | 'reset'
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (currentUser) {
      navigate('/mon-compte', { replace: true });
    }
  }, [currentUser, navigate]);

  const onChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
    setError('');
    setSuccess('');
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await login(form.email.trim(), form.password);
      if (!res.success) {
        setError(res.error || 'Identifiants invalides');
      }
    } catch (err) {
      setError('Une erreur est survenue, réessayez.');
    } finally {
      setLoading(false);
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');
    try {
      if (!form.email) { setError('Veuillez saisir votre email.'); setLoading(false); return; }
      await pb.collection('users').requestPasswordReset(form.email.trim());
      setSuccess("Un email de réinitialisation a été envoyé si cette adresse existe.");
    } catch (err) {
      setError("Impossible d'envoyer l'email de réinitialisation pour le moment.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '65vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem 1rem' }}>
      <div style={{ maxWidth: 520, width: '100%', background: 'var(--light-color)', color: 'var(--text-color)', border: '1px solid var(--border-color-extra-light, #e7e7e7)', borderRadius: 12, boxShadow: '0 10px 30px rgba(0,0,0,0.08)' }}>
        <div style={{ padding: '20px 20px 0', borderBottom: '1px solid var(--border-color-extra-light, #e7e7e7)', marginBottom: 16 }}>
          <h1 style={{ fontSize: 24, margin: 0, textAlign: 'center' }}>{mode === 'login' ? 'Connexion' : 'Mot de passe oublié'}</h1>
        </div>
        <div style={{ padding: '0 20px 20px' }}>
          {error && <div style={{ background: '#fef2f2', color: '#dc2626', padding: '10px 12px', borderRadius: 8, marginBottom: 10, borderLeft: '4px solid #dc2626' }}>{error}</div>}
          {success && <div style={{ background: '#f0fdf4', color: '#16a34a', padding: '10px 12px', borderRadius: 8, marginBottom: 10, borderLeft: '4px solid #16a34a' }}>{success}</div>}

          {mode === 'login' ? (
            <form onSubmit={handleLogin}>
              <div style={{ marginBottom: 12 }}>
                <label htmlFor="email" style={{ display: 'block', marginBottom: 6, fontWeight: 600 }}>Email</label>
                <input id="email" name="email" type="email" value={form.email} onChange={onChange} required style={{ width: '100%', padding: '12px 14px', border: '2px solid var(--border-color-extra-light,#e5e7eb)', borderRadius: 8 }} />
              </div>
              <div style={{ marginBottom: 12 }}>
                <label htmlFor="password" style={{ display: 'block', marginBottom: 6, fontWeight: 600 }}>Mot de passe</label>
                <input id="password" name="password" type="password" value={form.password} onChange={onChange} required minLength={6} style={{ width: '100%', padding: '12px 14px', border: '2px solid var(--border-color-extra-light,#e5e7eb)', borderRadius: 8 }} />
              </div>
              <button type="submit" disabled={loading} style={{ width: '100%', background: 'linear-gradient(135deg,#3b82f6 0%,#1d4ed8 100%)', color: '#fff', border: 'none', padding: '12px 16px', borderRadius: 8, fontWeight: 700, cursor: 'pointer' }}>
                {loading ? 'Chargement…' : 'Se connecter'}
              </button>
            </form>
          ) : (
            <form onSubmit={handleReset}>
              <div style={{ marginBottom: 12 }}>
                <label htmlFor="email" style={{ display: 'block', marginBottom: 6, fontWeight: 600 }}>Email</label>
                <input id="email" name="email" type="email" value={form.email} onChange={onChange} required style={{ width: '100%', padding: '12px 14px', border: '2px solid var(--border-color-extra-light,#e5e7eb)', borderRadius: 8 }} />
              </div>
              <button type="submit" disabled={loading} style={{ width: '100%', background: 'linear-gradient(135deg,#3b82f6 0%,#1d4ed8 100%)', color: '#fff', border: 'none', padding: '12px 16px', borderRadius: 8, fontWeight: 700, cursor: 'pointer' }}>
                {loading ? 'Chargement…' : 'Envoyer le lien de réinitialisation'}
              </button>
            </form>
          )}

          <div style={{ textAlign: 'center', paddingTop: 16, borderTop: '1px solid var(--border-color-extra-light,#e5e7eb)', marginTop: 16 }}>
            {mode === 'login' ? (
              <>
                <button type="button" onClick={() => setMode('reset')} style={{ background: 'none', border: 'none', color: 'var(--primary-color)', fontWeight: 700, cursor: 'pointer', textDecoration: 'underline' }}>
                  Mot de passe oublié ?
                </button>
                <div style={{ marginTop: 10 }}>
                  Pas encore de compte ? <NavLink to="/inscription" style={{ color: 'var(--primary-color)', fontWeight: 700, textDecoration: 'underline' }}>S'inscrire</NavLink>
                </div>
              </>
            ) : (
              <>
                <button type="button" onClick={() => setMode('login')} style={{ background: 'none', border: 'none', color: 'var(--primary-color)', fontWeight: 700, cursor: 'pointer', textDecoration: 'underline' }}>
                  Revenir à la connexion
                </button>
                <div style={{ marginTop: 10 }}>
                  Pas encore de compte ? <NavLink to="/inscription" style={{ color: 'var(--primary-color)', fontWeight: 700, textDecoration: 'underline' }}>S'inscrire</NavLink>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConnexionPage;
